/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mpay.vue?vue&type=template&id=6f2392e2&scoped=true"
import script from "./mpay.vue?vue&type=script&lang=js"
export * from "./mpay.vue?vue&type=script&lang=js"
import style0 from "./mpay.vue?vue&type=style&index=0&id=6f2392e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2392e2",
  null
  
)

export default component.exports